export const signin = {
  title: 'Bem-vindo à Antecipa.',
  reverseTitle: 'Bem-vindo ao Negocia',
  subtitle: 'Informe seu e-mail e senha.',
  forgotPassword: 'Esqueci minha senha',
  submit: 'Entrar',
  register: 'Não tenho conta. Quero ser cliente',
  corporateLogin: 'Login Corporativo',
  signinotp: 'Acessar apenas com seu e-mail',
  resetPassword: {
    title: 'Sua senha expirou',
    text: 'Digite o código enviado para seu e-mail e atualize sua senha em seguida.',
  },
  inputs: {
    email: 'E-mail',
    password: 'Senha',
  },
};
